// extracted by mini-css-extract-plugin
export default {"text":"styles_text__7-fUs","secondary":"styles_secondary__HEiCU"};